import React, { useContext } from "react";
import { RootStore } from "../RootStore";

// ---------- RootStoreContext ----------
export const RootStoreContext = React.createContext<RootStore>({} as RootStore);

// ---------- useRootStore ----------
export function useRootStore(): RootStore {
  const rootStore = useContext(RootStoreContext);
  if (rootStore === undefined) {
    /* istanbul ignore next */
    throw new Error("useRootStore must be used within a RootStoreProvider");
  }
  return rootStore;
}
